import { useTranslation } from 'react-i18next';

export default function FAQSchema() {
  const { t } = useTranslation('home');

  const faqItems = [1, 2, 3, 4, 5, 6].map(num => ({
    "@type": "Question",
    "name": t(`faq.q${num}.question`),
    "acceptedAnswer": {
      "@type": "Answer",
      "text": t(`faq.q${num}.answer`)
    }
  }));

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqItems
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
